import { Component, OnInit } from '@angular/core';
import { SharedService } from '../shared.service';
import { CommonModule } from '@angular/common';
import { empty } from 'rxjs';
import { ThisReceiver } from '@angular/compiler';
import { Router } from '@angular/router';
import { AppConfigService } from '../app-config.service';
@Component({
  selector: 'app-employee-view',
  templateUrl: './employee-view.component.html',
  styleUrls: ['./employee-view.component.scss']
})
export class EmployeeViewComponent implements OnInit {
  employee: any;
  loadedFlag: any = false;
  yearList: any = [];
  attendanceList: any = [];
  leaveList: any = [];
  clockifyList: any = [];
  monthList: any = [];
  employeeList: any = [];
  attendance: any;
  ModalTitle: any;
  activateModal: boolean = false;
  Date: any;
  month: any = 'January';
  monthNum: any = new Date().getMonth() + 1;
  monthDropdown =
    [
      { Value: 1, Text: 'January' },
      { Value: 2, Text: 'February' },
      { Value: 3, Text: 'March' },
      { Value: 4, Text: 'April' },
      { Value: 5, Text: 'May' },
      { Value: 6, Text: 'June' },
      { Value: 7, Text: 'July' },
      { Value: 8, Text: 'August' },
      { Value: 9, Text: 'September' },
      { Value: 10, Text: 'October' },
      { Value: 11, Text: 'November' },
      { Value: 12, Text: 'December' }
    ]
  dayList: any = [];
  year: any = new Date().getFullYear();
  yearDropdown: number[] = [];
  dateLastImported: any;
  dateLastImportedFor: any;
  settingId = 3;
  constructor(private service: SharedService, private router: Router, private appSettings: AppConfigService) { }
  ngOnInit(): void {
    var currentYear = new Date().getFullYear();
    this.yearDropdown = [];
    for (let yearItem = this.appSettings.getStartYear(); yearItem <= currentYear; yearItem++) {
      this.yearDropdown.push(yearItem);
    }
    this.service.currentEmployee.subscribe(data => {
      this.employee = data
      setTimeout(() => {
        this.RefreshAttendanceList(this.employee.pkEmpId, this.year);
        this.RefreshLeaveList(this.employee.pkEmpId, this.year);
        this.RefreshClockifyList(this.employee.ClockifyId, this.year);
      }, 200);
    });
    setTimeout(() => {
      this.FillDayList(this.dayList, 31);
    }, 200);
    this.RefreshYearList(this.year);
    if (this.employee !== null) {
      this.loadedFlag = true;
    }
    setTimeout(() => { this.service.ChangeEmpId2(this.employee.pkEmpId); }, 400);
    this.GetLastImportDate(this.settingId);
  }
  Test() {
    console.log(this.employee);
    console.log(this.clockifyList);
  }
  GetLastImportDate(settingId: number) {
    this.service.GetSetting(settingId).subscribe(data => {
      this.dateLastImported = data[0].LastImportDate,
      this.dateLastImportedFor = data[0].LastImportFor
    });
  }
  FillDayList(list: any, number: number) {
    if (list.length > 0) {
      return
    }
    else {
      for (let i = 1; i < number + 1; i++) {
        list.push(i);
      }
    }
  }
  RefreshEmployee(id: number) {
    this.service.GetEmployee(id).subscribe(data => {
      this.employee = data[0];
    });
  }
  RefreshYearList(year: number) {
    this.service.GetYear(year).subscribe(data => {
      this.yearList = data
    });
  }
  RefreshAttendanceList(id: number, year: any) {
    this.service.GetEmployeeAttendanceForYear(id, year).subscribe(data => {
      this.attendanceList = data
    });
  }
  RefreshLeaveList(id: number, year: number) {
    this.service.GetEmployeeLeaveForYear(id, year).subscribe(data => {
      this.leaveList = data
    });
  }
  RefreshClockifyList(clockifyId: string, year: number) {
    this.service.GetClockifyDataForYear(clockifyId, year).subscribe(data => {
      this.clockifyList = data
    });
  }
  Click(day: number, month: number) {
    this.Date = new Date(`${this.year}-${month}-${day} 00:00 PST`).toISOString().split('T')[0] + 'T00:00:00';
    this.ModalTitle = "View This Attendance Record";
    this.activateModal = true;
  }
  CloseClick() {
    this.activateModal = false;
  }
  IsLeapYear(year: number): boolean {
    return new Date(year, 1, 29).getDate() === 29;
  }
  IsShortMonth(day: number, month: number) {
    if (month == 2) {
      return (day > 28 && !this.IsLeapYear(this.year)) || day > 29;
    }
    else if (month == 4 || month == 6 || month == 9 || month == 11) {
      return day > 30;
    }
    return false;
  }
  CheckStatus(day: number, month: number) {
    var currentDate = new Date().toISOString().split('T')[0] + 'T00:00:00';
    var date = new Date(`${this.year}-${month}-${day} 00:00 PST`).toISOString().split('T')[0] + 'T00:00:00';
    var empId = this.employee.pkEmpId;
    var clockifyId = this.employee.ClockifyId;
    if (this.IsShortMonth(day, month)) {
      return 100
    }
    if (date < currentDate) {
      if (this.IsEmployeeTechnical(empId)) {
        if (this.IsWeekend(date)) {
          if (this.CheckClockifyPresence(date, clockifyId)) {
            if (this.CheckClockifyHours(date, empId, clockifyId) == 2) {
              return 3
            }
            else {
              return this.CheckClockifyHours(date, empId, clockifyId)
            }
          }
          else {
            return 3
          }
        }
        else if (this.IsPublicHoliday(date)) {
          if (this.CheckClockifyPresence(date, clockifyId)) {
            if (this.CheckClockifyHours(date, empId, clockifyId) == 2) {
              return 30
            }
            else {
              return this.CheckClockifyHours(date, empId, clockifyId)
            }
          }
          else {
            return 30
          }
        }
        else {
          return this.CheckClockifyHours(date, empId, clockifyId)
        }
      }
      else {
        if (this.IsWeekend(date)) {
          if (this.CheckAttendance(date, empId)) {
            //weekend - worked
            return 4
          }
          else {
            //weekend
            return 3
          }
        }
        else if (this.IsPublicHoliday(date)) {
          if (this.CheckAttendance(date, empId)) {
            return 4
          }
          else {
            return 30
          }
        }
        else {
          if (this.CheckAttendance(date, empId)) {
            // worked
            return this.CheckWorkHours(date, empId);
          }
          else {
            //absent
            return this.CheckMarkedLeave(date, empId)
          }
        }
      }
    }
    else {
      return 100
    }
  }
  IsWeekend(date: any) {
    for (let day of this.yearList) {
      // console.log(day.pkDate)
      if (day.pkDate == date) {
        if (day.IsWeekday == false) {
          return true
        }
        else {
          return false
        }
      }
    }
    return false
  }
  CheckClockifyPresence(date: any, clockifyId: any) {
    for (var clockify of this.clockifyList) {
      if (clockify.Date == date && clockify.ClockifyId == clockifyId) {
        return true
      }
    }
    return false
  }
  IsEmployeeTechnical(emp: any) {
    if (emp.ClockifyId != '') {
      return true
    }
    else {
      return false
    }
  }
  CheckClockifyHours(date: any, emp: number, clockifyId: any) {
    for (var clockify of this.clockifyList) {
      if (clockify.Date == date && clockify.ClockifyId == clockifyId) {
        if (clockify.WorkHours == 'Full') {
          return 1
        }
        else if (clockify.WorkHours == 'Half') {
          //half day
          return 7
        }
        else if (clockify.WorkHours == 'Quarter') {
          //quarter day
          return 8
        }
        else {
          return this.CheckMarkedLeave(date, emp)
        }
      }
    }
    return this.CheckMarkedLeave(date, emp)
  }
  CheckMarkedLeave(date: any, emp: number) {
    for (var leave of this.leaveList) {
      if (leave.Date == date && leave.fkEmpId == emp) {
        if (leave.Type == '') {
          return 2
        }
        else {
          return 20
        }
      }
    }
    return 2
  }
  IsPublicHoliday(date: any) {
    for (var day of this.yearList) {
      if (day.pkDate == date) {
        if (day.IsHoliday == true) {
          return true
        }
        else {
          return false
        }
      }
    }
    return false
  }
  CheckAttendance(date: any, emp: number) {
    for (var attendance of this.attendanceList) {
      if (attendance.Date == date) {
        if (attendance.fkEmpId == emp) {
          return true
        }
      }
    }
    return false
  }
  CheckWorkHours(date: any, emp: number) {
    for (var attendance of this.attendanceList) {
      if (attendance.Date == date && attendance.fkEmpId == emp) {
        if (attendance.WorkHours == 'Full') {
          return 1
        }
        else if (attendance.WorkHours == "Half") {
          return 5
        }
        else if (attendance.WorkHours == "Quarter") {
          return 6
        }
        else {
          return 0
        }
      }
    }
    return 0
  }
  GetHolidayName(day: number, month: number) {
    var date = new Date(`${this.year}-${month}-${day} 00:00 PST`).toISOString().split('T')[0] + 'T00:00:00';
    for (var tempDate of this.yearList) {
      if (tempDate.pkDate == date) {
        return tempDate.HolidayName;
      }
    }
    return 'Holiday name not found';
  }
  UpdateYear(year: number) {
    this.year = year;
    this.ngOnInit();
  }
  ViewReports() {
    this.service.ChangeEmpId2(this.employee.pkEmpId);
    this.router.navigate(['/employee-view-report'])
  }
  ViewRequests() {
    this.service.ChangeEmpId2(this.employee.pkEmpId);
    this.router.navigate(['/employee-view-request'])
  }
}